import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls, useRelations } from '@hooks/useCampaign'

import type { CampaignModel } from '@models/types'

const Campaign = (props: { campaign: Partial<CampaignModel> }) => {
  const { campaign, campaign: { id, title } } = props

  const { editCampaignUrl } = generateUrls(campaign)

  const campaignRelations = useRelations(campaign)
  const { agency } = campaignRelations

  return (
    <DashboardModuleListItem
      href={editCampaignUrl}
      secondaryText={agency.title}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default Campaign
